import { useNavigate } from 'react-router-dom';
import TimeFilters from '../../../../components/time-filters';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { apiService } from '../../../../services/api.service';
import { AppStore } from '../../../../store/store';
import { UserState } from '../../../../store/user.slice';
import StatisticSection from '../../../../components/statistics-section';
import StatisticsSectionBarChartType from '../../../../components/statistics-section.bar-chart-type';
import StatisticsSectionChartType from '../../../../components/statistics-section.chart-type';
import { colorsPalette } from '../../../../utils/colors-utils';
import { LabelValue } from '../../../../types/label-value.types';
import AppSelect from '../../../../components/form/base/app-select';
import { TransactionSummary } from '../../../../types/transaction.types';
import ReportsMerchantPartFilteredDataItem from './reports-merchant-page.part.filtered-data-item';
import './reports-merchant-page.scss';
import { getColorByStatusType, getColorByCardBrandType, transformTransactionsToChartLineData, transformCardBrandToChartLineData, transformToChartLineData } from '../../../../utils/constants';
import StatisticsSectionLineChart from '../../../../components/statistics-section.line-chart';
import { StatisticLineChartData } from '../../../../types/statistics.types';
import Button from '../../../../components/button';


const ReportsMerchantPage: React.FC = () => {
    const navigate = useNavigate();

    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();

    const [transactionsNumber, setTransactionsNumber] = useState();

    const [transactionsStatus, setTransactionsStatus] = useState();
    const [statusLoader, setStatusLoader] = useState(false);
    const [transactionsChartStatus, setTransactionsChartStatus] = useState<StatisticLineChartData[]>();
    const [transactionsChartLoader, setTransactionsChartLoader] = useState(false);

    const [cardTypes, setCardTypes] = useState([]);
    const [cardsLoader, setCardsLoader] = useState(false);
    const [cardChartTypes, setCardChartTypes] = useState<StatisticLineChartData[]>();
    const [cardChartLoader, setCardChartLoader] = useState(false);

    const [processors, setProcessors] = useState();
    const [processorsLoader, setProcessorsLoader] = useState(false);
    const [processorsChart, setProcessorsChart] = useState<StatisticLineChartData[]>();
    const [processorsChartLoader, setProcessorsChartLoader] = useState(false);

    const [mids, setMIDS] = useState();
    const [midsLoader, setMidsLoader] = useState(false);
    const [midsChart, setMidsChart] = useState<StatisticLineChartData[]>();
    const [midsChartLoader, setMidsChartLoader] = useState(false);


    const [merchantOptions, setMerchantOptions] = useState<LabelValue[]>([]);
    const [selectedMerchant, setSelectedMerchant] = useState('');
    const [midOptions, setMidOptions] = useState<LabelValue[]>([]);
    const [selectedMID, setSelectedMID] = useState('');
    const [transactionsSummary, setTransactionsSummary] = useState<TransactionSummary>();


    const { user } = useSelector<AppStore, UserState>((state) => state.user)

    const isMerchant = (user?.roles?.includes("merchant") || user?.roles?.includes("bas_merchant_view")) ?? false;



    useEffect(() => {

        apiService.getTransactionsSummary({ startDate, endDate, merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                setTransactionsSummary(response.data);
            })
            .catch((error) => console.error('Error fetching transactions summary:', error));

        apiService
            .getAllMerchants()
            .then((response) => {
                const transformedMerchants = response.data.map((merchant: any) => ({
                    label: merchant.lastName || merchant.lastName || 'Unknown',
                    value: merchant.id,
                }));
                setMerchantOptions([{
                    label: 'Reset',
                    value: '',
                }, ...transformedMerchants]);
            })
            .catch((error) => console.error('Error fetching merchants:', error));

        if (!isMerchant && selectedMerchant) {
            apiService.getMidsByMerchantAndProcessor({ merchantId: selectedMerchant, processorId: null })
                .then((response) => {
                    const transformedMids = response.data.map((mid: any) => ({
                        label: mid.midName || mid.midCode || 'Unknown',
                        value: mid.id,
                    }));
                    setMidOptions([{
                        label: 'Reset',
                        value: '',
                    }, ...transformedMids]);
                })
                .catch((error) => console.error('Error fetching mids:', error));
        }


        apiService.getTransactionsSummary({ startDate, endDate, merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => { setTransactionsNumber(response.data.transactionCount) })
            .catch((error) => console.error('Error fetching transactions number:', error));


        setStatusLoader(true)
        apiService.getTransactionsStatusStatistics({ startDate, endDate, merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const transformedData = response.data.map((item: any) => ({
                    color: getColorByStatusType(item.name),
                    name: item.name,
                    quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                    quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                    qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                    qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                }));
                setTransactionsStatus(transformedData);
            })
            .catch((error) => console.error('Error fetching transactions status:', error))
            .finally(() => setStatusLoader(false))

        setTransactionsChartLoader(true)
        apiService.getChartTransactionsData({ merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const transactionChartData: StatisticLineChartData[] = transformTransactionsToChartLineData(response.data);
                setTransactionsChartStatus(transactionChartData);
            })
            .catch((error) => console.error('Error fetching transactions chart status:', error))
            .finally(() => setTransactionsChartLoader(false))

        setCardsLoader(true)
        apiService.getCardTypeStatistics({ startDate, endDate, merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const transformedData = response.data.map((item: any) => ({
                    color: getColorByCardBrandType(item.name),
                    name: item.name,
                    quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                    quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                    qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                    qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                }));
                setCardTypes(transformedData);
            })
            .catch((error) => console.error('Error fetching card types:', error))
            .finally(() => setCardsLoader(false))

        setCardChartLoader(true)
        apiService.getChartCardData({ merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const cardsChartData: StatisticLineChartData[] = transformCardBrandToChartLineData(response.data);
                setCardChartTypes(cardsChartData);
            })
            .catch((error) => console.error('Error fetching card chart data:', error))
            .finally(() => setCardChartLoader(false))

        setProcessorsLoader(true)
        apiService.getProcessorStatistics({ startDate, endDate, merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const transformedData = response.data.map((item: any, index: number) => {
                    return ({
                        color: colorsPalette[index],
                        name: item.name,
                        type: isMerchant ? null : item.type,
                        quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                        quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                        qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                        qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                    })
                });
                setProcessors(transformedData);
            })
            .catch((error) => console.error('Error fetching processors:', error))
            .finally(() => setProcessorsLoader(false))


        setProcessorsChartLoader(true)
        apiService.getChartProcessorData({ merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const processorChartData: StatisticLineChartData[] = transformToChartLineData(response.data);
                setProcessorsChart(processorChartData);
            })
            .catch((error) => console.error('Error fetching processor chart data:', error))
            .finally(() => setProcessorsChartLoader(false))


        setMidsLoader(true)
        apiService.getMidStatistics({ startDate, endDate, merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const transformedData = response.data.map((item: any, index: number) => ({
                    id: item.id,
                    color: colorsPalette[index],
                    name: item.name,
                    quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                    quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                    qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                    qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                }));
                setMIDS(transformedData);
            })
            .catch((error) => console.error('Error fetching mids:', error))
            .finally(() => setMidsLoader(false))

        setMidsChartLoader(true)
        apiService.getChartMidData({ merchantId: selectedMerchant, midId: selectedMID })
            .then((response) => {
                const midsChartData: StatisticLineChartData[] = transformToChartLineData(response.data);
                setMidsChart(midsChartData);
            })
            .catch((error) => console.error('Error fetching processor chart data:', error))
            .finally(() => setMidsChartLoader(false))
    }, [user?.id, startDate, endDate, selectedMerchant, selectedMID]);


    const handleDataUpdate = (startDate?: string, endDate?: string, merchantId?: any) => {
        setStartDate(startDate);
        setEndDate(endDate);
    }

    return (
        <div className='reports-time-page page-content'>
            <div className="page-header flex-row flex-gap-20 flex-align-start-center width-100 flex-wrap">
                <div className='page-title'>
                    Reports Merchant
                </div>
                <Button
                    theme="accent"
                    label="Generate Settlement"
                    onClick={() => { navigate('/app/dashboard/generate-settlement') }}
                />

                <Button
                    theme="accent"
                    label="Generate RR Release"
                    onClick={() => { navigate('/app/dashboard/generate-rr-release') }}
                />
            </div>

            <div className='flex-row width-100 flex-align-start-start flex-wrap flex-gap-30'>
                <TimeFilters transactionsNo={transactionsNumber} handleFilters={handleDataUpdate} />
                <AppSelect
                    theme='filter'
                    options={merchantOptions}
                    value={selectedMerchant}
                    placeholder='Select Merchant'
                    onChange={(value) => {
                        setSelectedMID('')
                        setSelectedMerchant(value)
                    }}
                />
                <AppSelect
                    theme='filter'
                    value={selectedMID}
                    options={midOptions}
                    placeholder='Select MID'
                    onChange={(value) => setSelectedMID(value)}
                />
                <div className='flex-row flex-align-end-end flex-1'>

                    {/* <ReportsMerchantPartFilteredDataItem
                        total={transactionsSummary?.totalAmount || 0}
                        noTransactions={transactionsSummary?.transactionCount || 0}
                        filters={{ startDate, endDate, merchantId: selectedMerchant, midId: selectedMID }}
                    /> */}
                </div>
            </div>

            <StatisticSection title='Status Statistics'>
                <StatisticsSectionChartType data={transactionsStatus || []} isLoading={statusLoader} />
                <StatisticsSectionLineChart data={transactionsChartStatus || []} isLoading={transactionsChartLoader} />
            </StatisticSection>
            <StatisticSection title='Card Brand Statistics'>
                <StatisticsSectionChartType data={cardTypes || []} isLoading={cardsLoader} />
                <StatisticsSectionLineChart data={cardChartTypes || []} isLoading={cardChartLoader} />
            </StatisticSection>
            <StatisticSection title='Processors Statistics'>
                <StatisticsSectionBarChartType data={processors || []} isLoading={processorsLoader} />
                <StatisticsSectionLineChart data={processorsChart || []} isLoading={processorsChartLoader} />
            </StatisticSection>
            <StatisticSection title='MIDs Statistics'>
                <StatisticsSectionBarChartType data={mids || []} isLoading={midsLoader} />
                <StatisticsSectionLineChart data={midsChart || []} isLoading={midsChartLoader} />
            </StatisticSection>
        </div>
    )
}

export default ReportsMerchantPage